import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-sanjiaoxia",
  "use": "icon-sanjiaoxia-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-sanjiaoxia\"><defs><style></style></defs><path d=\"M996.727 270.387L511.505 754.62 27.272 269.398z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol